import React, {useEffect, useMemo, useRef, useState} from "react";
import {useAppDispatch, useAppSelector} from 'redux/hooks'
import {Button} from "primereact/button";
import {MultiSelect} from "primereact/multiselect";
import {OverlayPanel} from "primereact/overlaypanel";
import {Tag} from "primereact/tag";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Calendar} from "primereact/calendar";
// import {Checkbox} from "primereact/checkbox";
import {Dropdown} from "primereact/dropdown";
import {Paginator} from "primereact/paginator";
import {ConfirmDialog} from "primereact/confirmdialog";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {
    deleteAllQualityControlStatisticsFiles,
    deleteQualityControlStatisticsFileById,
    generateQualityControlStatisticExcel,
    getQualityControlStatisticExcelByLink,
    getQualityControlStatisticsFilesHistory,
    updateUserQualityControlStatisticFields,
} from "../../../../redux/api/apiQualityControlStatistics";
import {
    setQualityControlStatisticsFilesCurrentPage,
    setQualityControlStatisticsFilesCurrentPageSize,
} from "../../../../redux/actions/actionsQualityControlStatistics";
import {SET_UPLOAD_FILE_STATUS_SUCCESS} from "../../../../redux/types/typesUsersList";
import {getQualityControlStatisticsFieldLabel, isRemovedQualityControlStatisticsField} from "../qualityControlStatisticsFields";

const QualityControlStatisticsListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const qualityControlPermissions = checkPermissions(rolesVision, 'QualityControlStatistic');
    const exportLoading = useAppSelector(state => state.QualityControlStatisticsReducer.exportLoading);
    const statisticsList = useAppSelector(state => state.QualityControlStatisticsReducer?.statisticsList);
    const filesHistory = useAppSelector(state => state.QualityControlStatisticsReducer?.filesHistory);
    const filesHistoryLoader = useAppSelector(state => state.QualityControlStatisticsReducer?.filesHistoryLoader);
    const filesPagination = useAppSelector(state => state.QualityControlStatisticsReducer?.filesPagination);
    const filesPaginationPage = useAppSelector(state => state.QualityControlStatisticsReducer?.filesPaginationPage);
    const filesPaginationSize = useAppSelector(state => state.QualityControlStatisticsReducer?.filesPaginationSize);
    const sortFields = useMemo(
        () => (props.userSortFields || []).filter((field: { name?: string }) => !isRemovedQualityControlStatisticsField(field.name)),
        [props.userSortFields],
    );
    const [selectedFields, setSelectedFields] = useState<any>(sortFields);
    const op = useRef(null);
    const excelToast = useRef<any>(null);
    const minDate = new Date(2023, 5, 1);
    const [hasTableData, setHasTableData] = useState(false);
    const [first, setFirst] = useState(0);
    const [filesTotalItems, setFilesTotalItems] = useState<number>(10);
    const [filesHistoryItems, setFilesHistoryItems] = useState<any>(filesHistory);
    const [newFileNotify, setNewFileNotify] = useState<boolean>(false);
    const [visibleDeleteAllFilesMessage, setVisibleDeleteAllFilesMessage] = useState(false);
    const [visible, setVisible] = useState(false);
    const [currentId, setCurrentId] = useState<any>(null);
    const [isFilesPanelVisible, setIsFilesPanelVisible] = useState(false);

    const getDefaultStartTime = () => {
        return new Date("2024-10-29 00:00:00");
    };

    const getDefaultEndTime = () => {
        const d = new Date();
        d.setHours(23, 59, 59, 0);
        return d;
    };

    const getDefaultStartDate = () => {
        return new Date();
    };

    const getDefaultEndDate = () => {
        return new Date();
    };

    const {
        update: hasUpdatePermission,
    } = qualityControlPermissions;

    useEffect(() => {
        setSelectedFields(sortFields);
    }, [sortFields]);

    useEffect(() => {
        setHasTableData(Array.isArray(statisticsList) && statisticsList.length > 0);
    }, [statisticsList]);

    useEffect(() => {
        setFilesHistoryItems(filesHistory);
    }, [filesHistory]);

    useEffect(() => {
        if (filesPagination?.hasNext && filesPagination?.pageNumber) {
            setFilesTotalItems(filesPagination.pageNumber * filesPaginationSize + filesPaginationSize);
        } else if (!filesPagination?.hasNext) {
            setFilesTotalItems(filesPagination.pageNumber * filesPaginationSize);
        }
    }, [filesPagination, filesPaginationSize]);

    useEffect(() => {
        dispatch(setQualityControlStatisticsFilesCurrentPage(1));
        dispatch(setQualityControlStatisticsFilesCurrentPageSize(10));
    }, [dispatch]);

    const filteredObject = {
        sort: props.sortData?.sort,
        filter: props.sortData?.filter,
        username: user?.userName,
    };

    const handleGenerateTable = () => {
        dispatch(generateQualityControlStatisticExcel(filteredObject, jwtToken?.jwtToken))
            ?.then?.((isSuccess: boolean) => {
                if (isSuccess) {
                    setNewFileNotify(true);
                }
            });
    };

    const openFilesPanel = (e: React.SyntheticEvent) => {
        if (!isFilesPanelVisible) {
            dispatch(getQualityControlStatisticsFilesHistory({
                pageNumber: filesPaginationPage || 1,
                pageSize: filesPaginationSize || 10,
            }, jwtToken?.jwtToken));
            dispatch({type: SET_UPLOAD_FILE_STATUS_SUCCESS, payload: null});
            setNewFileNotify(false);
        }
        setIsFilesPanelVisible(true);
        excelToast.current?.toggle(e);
    };

    const onFilesPageChange = (event: {first: number; page: number; rows: number}) => {
        setFirst(event.first);
        dispatch(setQualityControlStatisticsFilesCurrentPage(event.page + 1));
        dispatch(setQualityControlStatisticsFilesCurrentPageSize(event.rows));
        dispatch(getQualityControlStatisticsFilesHistory({
            pageNumber: event.page + 1,
            pageSize: event.rows,
        }, jwtToken?.jwtToken));
    };

    const handleUpload = (id: number) => {
        dispatch(getQualityControlStatisticExcelByLink(id, jwtToken?.jwtToken));
    };

    const uploadByUrl = (fileUrl: any, fileName: any) => {
        if (fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
    };

    const handleDeleteFile = (id: number) => {
        dispatch(deleteQualityControlStatisticsFileById(id, {
            pageNumber: filesPaginationPage || 1,
            pageSize: filesPaginationSize || 10,
        }, jwtToken?.jwtToken));
    };

    const acceptDeleteFile = () => {
        handleDeleteFile(currentId);
        setVisible(false);
    };

    const bodyExcelUpload = (rowData: any) => (
        <div className="flex justify-content-center">
            {!rowData?.tempUrl ? (
                <Button onClick={() => handleUpload(rowData?.id)} icon="pi pi-download" className="p-button-secondary ml-auto mr-2" />
            ) : (
                <Button
                    icon="pi pi-download"
                    className="p-button-secondary ml-auto mr-2"
                    onClick={() => uploadByUrl(rowData?.tempUrl, rowData?.fileName)}
                />
            )}
            <Button
                onClick={() => {
                    setCurrentId(rowData?.id);
                    setVisible(true);
                }}
                icon="pi pi-trash"
                className="p-button-secondary mx-auto"
            />
        </div>
    );

    const bodyExcelId = (rowData: any) => (
        <div className="flex justify-content-center">{rowData?.id}</div>
    );

    const renderFilesButton = (className = 'mr-2 mb-2') => (
        <Button
            style={{backgroundColor: '#1d6f42'}}
            className={`p-button-success text-white ${className} ${newFileNotify ? 'animate-bounce-loop' : 'shadow-none'}`}
            type="button"
            icon="pi pi-download"
            onClick={openFilesPanel}
        />
    );

    const renderFilesDialogs = () => (
        <>
            <ConfirmDialog
                style={{zIndex: 9999999999999}}
                visible={visible}
                onHide={() => setVisible(false)}
                message="Файл буде видалено зі списку, продовжити ?"
                header="Попередження"
                acceptLabel="Так"
                rejectLabel="Ні"
                icon="pi pi-exclamation-triangle"
                accept={acceptDeleteFile}
                reject={() => setVisible(false)}
            />
            <ConfirmDialog
                visible={visibleDeleteAllFilesMessage}
                style={{zIndex: 99999999999999}}
                onHide={() => setVisibleDeleteAllFilesMessage(false)}
                message="Всі файли будуть видалені, продовжити ?"
                header="Попередження"
                acceptLabel="Так"
                rejectLabel="Ні"
                icon="pi pi-exclamation-triangle"
                accept={() => {
                    setVisibleDeleteAllFilesMessage(false);
                    dispatch(deleteAllQualityControlStatisticsFiles(jwtToken?.jwtToken));
                    excelToast.current?.hide();
                }}
                reject={() => setVisibleDeleteAllFilesMessage(false)}
            />
            <OverlayPanel
                className="excelPanel"
                ref={excelToast}
                style={{minWidth: '38rem'}}
                onHide={() => setIsFilesPanelVisible(false)}
            >
                <div className="flex justify-content-end align-items-center">
                    <Button
                        type="button"
                        disabled={filesHistory?.length < 1}
                        label="Видалити все"
                        icon="pi pi-trash"
                        className="p-button-outlined mr-4"
                        onClick={() => {
                            excelToast.current?.hide();
                            setVisibleDeleteAllFilesMessage(true);
                        }}
                    />
                    <Button
                        onClick={() => {
                            excelToast.current?.hide();
                            setNewFileNotify(false);
                        }}
                        icon="pi pi-times"
                        className="p-button-secondary"
                    />
                </div>
                <DataTable
                    loading={filesHistoryLoader}
                    emptyMessage="Файлів поки немає"
                    style={{minWidth: '300px'}}
                    value={filesHistoryItems}
                >
                    <Column field="id" header="ID" body={bodyExcelId} />
                    <Column field="fileName" header="Назва" />
                    <Column field="code" header="Дія" style={{maxWidth: '100px'}} body={bodyExcelUpload} />
                </DataTable>
                <Paginator
                    first={first}
                    rows={filesPaginationSize || 10}
                    totalRecords={filesTotalItems}
                    rowsPerPageOptions={[5, 10, 15, 25, 50]}
                    onPageChange={onFilesPageChange}
                    className="border-top-1 border-bottom-1"
                    template="PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
                />
            </OverlayPanel>
        </>
    );

    const onColumnToggle = (e: { value: { name: any; }[]; }) => {
        const updatedFields = selectedFields.map((field: { name: any; inSystem: any; }) => {
            if (!field.inSystem) {
                return {
                    ...field,
                    isActive: e.value.some((selected: { name: any; }) => selected.name === field.name)
                };
            }
            return field;
        });
        setSelectedFields(updatedFields);
    };

    const saveUserFields = () => {
        dispatch(updateUserQualityControlStatisticFields(selectedFields, jwtToken?.jwtToken));
    };

    const itemTemplate = (option: any) => (
        <div className="custom-item">
            <span>{getQualityControlStatisticsFieldLabel(option.name)}</span>
        </div>
    );

    const questionnaireItemTemplate = (option: any) => {
        if (!option) {
            return null;
        }

        return (
            <div className="flex justify-content-between">
                <div>{option.searchLabel}</div>
                <div className="ml-3 text-sm">{option?.isArchived && 'Архів'}</div>
            </div>
        );
    };

    const selectedItemTemplate = (option: any) => {
        if (!option) {
            return <p className="opacity-50">Нічого не обрано</p>;
        }

        return <Tag
            value={getQualityControlStatisticsFieldLabel(option.name)}
            className="custom-chip"
        ></Tag>;
    };

    const onRowReorder = (e: { dragIndex: number; dropIndex: number; }) => {
        let updatedRows = [...selectedFields];
        const draggedRow = updatedRows[e.dragIndex];

        updatedRows.splice(e.dragIndex, 1);
        updatedRows.splice(e.dropIndex, 0, draggedRow);

        updatedRows = updatedRows.map((row, index) => ({
            ...row,
            order: index + 1
        }));

        setSelectedFields(updatedRows);
    }

    const handleDelete = (index: number) => {
        const updatedFields = selectedFields.map((field: any, i: number) =>
            i === index ? {...field, isActive: false} : field
        );
        setSelectedFields(updatedFields);
    }

    const columnGroupItems = () => {
        const filteredData = selectedFields
            ?.filter((field: { isActive: boolean; }) => field.isActive)
            ?.sort((a: { order: number }, b: { order: number }) => a.order - b.order);

        const filteredArray = filteredData?.map((item: any, index: number) => ({
            ...item,
            order: index + 1,
        }));

        const nameField = (rowData: any) => (
            <p className="m-0">{getQualityControlStatisticsFieldLabel(rowData.name)}</p>
        );

        const buttonTemplate = (rowData: any) => {
            const originalIndex = selectedFields.findIndex((field: any) => field.name === rowData.name);
            return !rowData?.inSystem ? (
                <Button
                    onClick={() => handleDelete(originalIndex)}
                    icon="pi pi-times"
                    className="delete-user p-button-secondary p-button-rounded p-button-text field col-12 md:col-2 mb-0 px-0"
                    disabled={!hasUpdatePermission}
                />
            ) : <></>;
        }

        return <DataTable className="w-full table-selected-fields" value={filteredArray} reorderableColumns reorderableRows
                          onRowReorder={onRowReorder}>
            <Column className="custom-column-width-20" rowReorder style={{width: '20px', maxWidth: '20px'}}/>
            <Column field="order" className="text-center" style={{minWidth: '10px', width: '40px', maxWidth: '40px'}}/>
            <Column field="name" body={nameField} style={{minWidth: '50%', maxWidth: '70%', justifyContent: 'flex-start'}}/>
            <Column body={buttonTemplate} style={{width: '20px', padding: 0, maxWidth: '20px'}}/>
        </DataTable>
    };

    const isDisabled = () => {
        return !props.endTime || !props.startTime || !props.filterDateTime || !props.filterEndDateTime;
    };

    const bindDateInput = (
        e: any,
        setter: (value: Date | null) => void,
    ) => {
        const input = e.target as HTMLInputElement;
        const digits = input.value.replace(/\D/g, "").slice(0, 8);
        const dd = digits.slice(0, 2);
        const mm = digits.slice(2, 4);
        const yyyy = digits.slice(4, 8);
        const display =
            (dd || "") +
            (digits.length > 2 ? "/" + mm : "") +
            (digits.length > 4 ? "/" + yyyy : "");
        const newCaret =
            digits.length +
            (digits.length > 2 ? 1 : 0) +
            (digits.length > 4 ? 1 : 0);

        if (input.value !== display) {
            input.value = display;
            input.setSelectionRange(newCaret, newCaret);
        }

        if (digits.length === 8) {
            const day = parseInt(dd, 10);
            const month = parseInt(mm, 10) - 1;
            const year = parseInt(yyyy, 10);
            const parsed = new Date(year, month, day);
            const valid =
                !isNaN(parsed.getTime()) &&
                parsed.getDate() === day &&
                parsed.getMonth() === month &&
                parsed.getFullYear() === year &&
                parsed >= minDate;

            setter(valid ? parsed : null);
        }
    };

    const bindTimeInput = (
        e: any,
        currentValue: Date | null,
        setter: (value: Date) => void,
    ) => {
        const input = e.target as HTMLInputElement;
        const digits = input.value.replace(/\D/g, "").slice(0, 4);
        const HH = digits.slice(0, 2);
        const MM = digits.slice(2, 4);
        const display = HH + (digits.length > 2 ? ":" + MM : "");

        if (input.value !== display) {
            const caret = digits.length + (digits.length > 2 ? 1 : 0);
            input.value = display;
            input.setSelectionRange(caret, caret);
        }

        if (digits.length === 4) {
            const h = parseInt(HH, 10);
            const m = parseInt(MM, 10);
            const valid = h >= 0 && h <= 23 && m >= 0 && m <= 59;
            if (valid) {
                const base = currentValue ? new Date(currentValue) : new Date();
                base.setHours(h, m, 0, 0);
                setter(base);
            }
        }
    };

    return (
        <>
            <div className="table-buttons">
                <div className="text-normal-weight flex align-items-center">
                    <Button className="mb-2" type="button" icon="pi pi-cog"
                            onClick={(e) => {
                                // @ts-ignore
                                op.current.toggle(e);
                                setSelectedFields(sortFields);
                            }}/>
                    <div className="flex field align-items-center max-w-15rem ml-4 desktop-filter">
                        <span className="title pt-2" style={{width: '25px'}}>З*</span>
                        <Calendar className="mt-2" value={props.filterDateTime ? props.filterDateTime : null}
                                  disabled={props.allTimeChecked}
                                  onChange={(e: any) => props.setFilterDateTime(e.value)}
                                  onInput={(e: any) => bindDateInput(e, props.setFilterDateTime)}
                                  onFocus={() => {
                                      if (props.filterDateTime) {
                                          props.setFilterDateTime(null);
                                      }
                                  }}
                                  onBlur={(e: any) => {
                                      const digits = e.target.value.replace(/\D/g, "");
                                      if (digits.length !== 8) {
                                          e.target.value = "";
                                          props.setFilterDateTime(null);
                                      }
                                      if (!props.filterDateTime) {
                                          props.setFilterDateTime(getDefaultStartDate());
                                      }
                                  }}
                                  minDate={minDate}
                                  maxDate={new Date()}
                                  dateFormat="dd/mm/yy" placeholder="дд/мм/рр"/>
                        <Calendar
                            key={`start-time-${props.allTimeChecked}`}
                            appendTo="self"
                            id="icon"
                            className="mt-2 ml-2"
                            placeholder="00:00"
                            value={props.startTime ?? null}
                            timeOnly
                            hourFormat="24"
                            disabled={props.allTimeChecked}
                            onChange={(e) => {
                                if (e.value) props.setStartTime(e.value);
                            }}
                            onFocus={() => props.setStartTime(null)}
                            onBlur={() => {
                                if (!props.startTime) {
                                    props.setStartTime(getDefaultStartTime());
                                }
                            }}
                            onInput={(e: any) => bindTimeInput(e, props.startTime, props.setStartTime)}
                        />
                    </div>
                    <div className="flex field align-items-center max-w-15rem ml-2 desktop-filter">
                        <span className="title pt-2" style={{width: '35px'}}>По*</span>
                        <Calendar
                            className="mt-2"
                            value={props.filterEndDateTime || null}
                            onChange={(e: any) => props.setFilterEndDateTime(e.value)}
                            minDate={minDate}
                            maxDate={new Date()}
                            onInput={(e: any) => bindDateInput(e, props.setFilterEndDateTime)}
                            onFocus={() => {
                                if (props.filterEndDateTime) {
                                    props.setFilterEndDateTime(null);
                                }
                            }}
                            onBlur={(e: any) => {
                                const digits = e.target.value.replace(/\D/g, "");
                                if (digits.length !== 8) {
                                    e.target.value = "";
                                    props.setFilterEndDateTime(null);
                                }
                                if (!props.filterEndDateTime) {
                                    props.setFilterEndDateTime(getDefaultEndDate());
                                }
                            }}
                            dateFormat="dd/mm/yy"
                            placeholder="дд/мм/рр"
                            disabled={props.allTimeChecked}
                        />
                        <Calendar
                            key={`end-time-${props.allTimeChecked}`}
                            appendTo="self"
                            id="icon"
                            className="mt-2 ml-2"
                            placeholder="00:00"
                            value={props.endTime ? props.endTime : null}
                            timeOnly
                            hourFormat="24"
                            disabled={props.allTimeChecked}
                            onChange={(e) => {
                                if (e.value) props.setEndTime(e.value);
                            }}
                            onFocus={() => props.setEndTime(null)}
                            onBlur={() => {
                                if (!props.endTime) {
                                    props.setEndTime(getDefaultEndTime());
                                }
                            }}
                            onInput={(e: any) => bindTimeInput(e, props.endTime, props.setEndTime)}
                        />
                    </div>
                    {/* <div
                        className="flex align-items-center border-round-lg border-gray-600 border-1 p-2 pt-1 mb-2 ml-2 desktop-filter">
                        <Checkbox className="mr-2" onChange={e => props.setAllTimeChecked(e.checked)}
                                  checked={props.allTimeChecked}/>
                        <label>За весь час</label>
                    </div> */}
                    <div className="flex field align-items-center ml-2 desktop-filter">
                        <Dropdown
                            value={props.selectedQuestionnaireId}
                            options={props.questionnaireOptions || []}
                            onChange={(e) => props.setSelectedQuestionnaireId(e.value ?? null)}
                            optionLabel="searchLabel"
                            optionValue="id"
                            placeholder="Оберіть анкету"
                            className="mt-2"
                            style={{minWidth: '220px'}}
                            filter
                            filterPlaceholder="Введіть назву"
                            showClear
                            resetFilterOnHide
                            scrollHeight="250px"
                            itemTemplate={questionnaireItemTemplate}
                        />
                    </div>
                    <Button disabled={isDisabled()} onClick={() => {
                        props.setHasStartFilter(!props.hasStartFilter);
                        if (props.allTimeChecked === null) {
                            props.setAllTimeChecked(false)
                        }
                    }}
                            icon="pi pi-search" className="mb-2 ml-2 desktop-filter"/>
                    <OverlayPanel ref={op}>
                        <div className="flex flex-column">
                            <div className="mb-3 text-bold">Виберіть стовпці для відображення:</div>
                            <MultiSelect
                                value={selectedFields?.filter((field: any) => !field.inSystem && field?.isActive)}
                                options={selectedFields?.filter((field: { inSystem: any }) => !field.inSystem)}
                                optionLabel="name"
                                onChange={onColumnToggle}
                                className="w-full mb-2 sm:max-w-20rem max-w-14rem"
                                display="chip"
                                filter
                                selectedItemTemplate={selectedItemTemplate}
                                itemTemplate={itemTemplate}
                            />
                            {
                                selectedFields?.length ?
                                    <div className="users-list">
                                        {columnGroupItems()}
                                    </div>
                                    :
                                    <span className="no-users-message">Груп не обрано</span>
                            }
                            <div className="flex justify-content-between field mt-2 mb-0">
                                <Button icon="pi pi-times"
                                        className="p-button p-component p-button-secondary p-button-icon-only"
                                        onClick={(e) => {
                                            // @ts-ignore
                                            op.current.toggle(e)
                                        }}></Button>
                                <Button icon="pi pi-check" onClick={() => {
                                    saveUserFields();
                                    // @ts-ignore
                                    op.current.hide();
                                }}></Button>
                            </div>
                        </div>
                    </OverlayPanel>
                </div>
                <div className="desktop flex align-items-center">
                    {hasUpdatePermission && renderFilesButton()}
                    {hasUpdatePermission && (
                        <Button
                            onClick={handleGenerateTable}
                            label="Сформувати таблицю"
                            loading={exportLoading}
                            disabled={!hasTableData}
                            icon="pi pi-file-excel"
                            style={{backgroundColor: '#1d6f42'}}
                            className="mr-2 mb-2 p-button-success text-white shadow-none"
                        />
                    )}
                    <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри"
                            className="p-button-outlined mr-2 mb-2" onClick={() => {
                        props.resetSorting();
                    }}/>
                </div>
                <div className="mobile">
                    {hasUpdatePermission && renderFilesButton()}
                    {hasUpdatePermission && (
                        <Button
                            onClick={handleGenerateTable}
                            icon="pi pi-file-excel"
                            loading={exportLoading}
                            disabled={!hasTableData}
                            style={{backgroundColor: '#1d6f42'}}
                            className="mr-2 mb-2 p-button-success text-white shadow-none"
                        />
                    )}
                    <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined mr-2 mb-2"
                            onClick={() => props.resetSorting()}/>
                </div>
            </div>
            <div className="flex align-items-center flex-wrap">
                <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6' : `md:col-4`} sm:col-6 field align-items-center mobile-filter mb-1 px-0`}>
                    <span className="title pt-2" style={{minWidth: '35px'}}>З*</span>
                    <Calendar className="mt-2 w-full" value={props.filterDateTime ? props.filterDateTime : null}
                              onChange={(e: any) => props.setFilterDateTime(e.value)}
                              onInput={(e: any) => bindDateInput(e, props.setFilterDateTime)}
                              onFocus={() => {
                                  if (props.filterDateTime) {
                                      props.setFilterDateTime(null);
                                  }
                              }}
                              onBlur={(e: any) => {
                                  const digits = e.target.value.replace(/\D/g, "");
                                  if (digits.length !== 8) {
                                      e.target.value = "";
                                      props.setFilterDateTime(null);
                                  }
                                  if (!props.filterDateTime) {
                                      props.setFilterDateTime(getDefaultStartDate());
                                  }
                              }}
                              minDate={minDate}
                              maxDate={new Date()}
                              dateFormat="dd/mm/yy" disabled={props.allTimeChecked} placeholder="дд/мм/рр"/>
                    <Calendar
                        key={`start-time-mobile-${props.allTimeChecked}`}
                        appendTo="self"
                        id="icon"
                        className="mt-2 ml-2 w-full"
                        placeholder="00:00"
                        disabled={props.allTimeChecked}
                        value={props.startTime ? props.startTime : null}
                        timeOnly
                        hourFormat="24"
                        onChange={(e) => {
                            if (e.value) props.setStartTime(e.value);
                        }}
                        onFocus={() => props.setStartTime(null)}
                        onBlur={() => {
                            if (!props.startTime) {
                                props.setStartTime(getDefaultStartTime());
                            }
                        }}
                        onInput={(e: any) => bindTimeInput(e, props.startTime, props.setStartTime)}
                    />
                </div>
                <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6' : `md:col-4`} sm:col-6 field align-items-center mobile-filter mb-1 px-0`}>
                    <span className="title pt-2" style={{minWidth: '35px'}}>По*</span>
                    <Calendar className="mt-2 w-full" value={props.filterEndDateTime ? props.filterEndDateTime : null}
                              onChange={(e: any) => props.setFilterEndDateTime(e.value)}
                              onInput={(e: any) => bindDateInput(e, props.setFilterEndDateTime)}
                              onFocus={() => {
                                  if (props.filterEndDateTime) {
                                      props.setFilterEndDateTime(null);
                                  }
                              }}
                              onBlur={(e: any) => {
                                  const digits = e.target.value.replace(/\D/g, "");
                                  if (digits.length !== 8) {
                                      e.target.value = "";
                                      props.setFilterEndDateTime(null);
                                  }
                                  if (!props.filterEndDateTime) {
                                      props.setFilterEndDateTime(getDefaultEndDate());
                                  }
                              }}
                              minDate={minDate}
                              maxDate={new Date()}
                              dateFormat="dd/mm/yy" disabled={props.allTimeChecked} placeholder="дд/мм/рр"/>
                    <Calendar
                        key={`end-time-mobile-${props.allTimeChecked}`}
                        appendTo="self"
                        id="icon"
                        className="mt-2 ml-2 w-full"
                        placeholder="00:00"
                        disabled={props.allTimeChecked}
                        value={props.endTime ? props.endTime : null}
                        timeOnly
                        hourFormat="24"
                        onChange={(e) => {
                            if (e.value) props.setEndTime(e.value);
                        }}
                        onFocus={() => props.setEndTime(null)}
                        onBlur={() => {
                            if (!props.endTime) {
                                props.setEndTime(getDefaultEndTime());
                            }
                        }}
                        onInput={(e: any) => bindTimeInput(e, props.endTime, props.setEndTime)}
                    />
                </div>
                <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6' : `md:col-4`} sm:col-12 field align-items-center mobile-filter mb-1 px-0`}>
                    <Dropdown
                        value={props.selectedQuestionnaireId}
                        options={props.questionnaireOptions || []}
                        onChange={(e) => props.setSelectedQuestionnaireId(e.value ?? null)}
                        optionLabel="searchLabel"
                        optionValue="id"
                        placeholder="Оберіть анкету"
                        className="mt-2 w-full"
                        filter
                        filterPlaceholder="Введіть назву"
                        showClear
                        resetFilterOnHide
                        scrollHeight="250px"
                        itemTemplate={questionnaireItemTemplate}
                    />
                </div>
                <div className={`col-12 ${props?.profileMenuPin ? 'md:col-6 md:mb-2' : `md:col-4 md:mb-0`} sm:col-12 mb-2 sm:mb-0 p-0 sm:mb-2 justify-content-between flex sm:justify-content-between md:justify-content-start`}>
                    {/* <div
                        className="align-items-center border-round-lg border-gray-600 border-1 p-2 pt-1 mx-0 md:mx-2 mobile-filter">
                        <Checkbox className="mr-2" onChange={e => props.setAllTimeChecked(e.checked)}
                                  checked={props.allTimeChecked}/>
                        <label>За весь час</label>
                    </div> */}
                    <Button onClick={() => props.setHasStartFilter(!props.hasStartFilter)}
                            disabled={isDisabled()}
                            icon="pi pi-search" label="Пошук" className="mobile-filter mobile-filter-btn"
                            style={{minWidth: '30px'}}/>
                </div>
            </div>
            {hasUpdatePermission && renderFilesDialogs()}
        </>
    )
}

export default QualityControlStatisticsListNav;
